export enum EventTypeSelectMode {
  single = 'single',
  multiple = 'multiple',
  none = 'none',
}
